import { MomentAttributes } from '@jellyvision/storybook-runtime/dist/StorybookRuntime/adapters';
import { Copy, ArrowRight } from '@phosphor-icons/react';
import React from 'react';

import { ContentfulMomentSidebar } from 'ContentfulDefaults/types/momentSidebar';

import {
  SidebarWrapper,
  Title,
  Subheader,
  CTAButton,
  CodeContainer,
  CodeBox,
  CopyIconWrapper,
  CopiedComponent,
  CopiedWrapper,
  CopiedIcon,
} from './styled';

interface MomentSidebarProps {
  content: ContentfulMomentSidebar;
  button_link?: string;
  signup_code?: string;
  sendAnalyticsEvent: (eventName: string, eventAttributes?: MomentAttributes) => void;
  topic?: string;
  isTalkspace?: boolean;
}

export const MomentSidebar = ({
  content,
  button_link = '#',
  signup_code,
  sendAnalyticsEvent,
  isTalkspace,
  topic,
}: MomentSidebarProps) => {
  const [copied, setCopied] = React.useState(false);

  const sidebarItem =
    content.moment_sidebars.find((item) => item.topic?.toLowerCase() === topic?.toLowerCase()) ||
    content.moment_sidebars[0]; // fallback to first if topic not found

  const { button_label, header_mtm, sub_header, button_header } = sidebarItem;
  const handleCopy = () => {
    if (signup_code) {
      navigator.clipboard.writeText(signup_code).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 4000);
      });
    }
  };

  const sendInsightsOnCTAClick = () => {
    // Teladoc link will work for Teladoc MtM content
    if (isTalkspace) {
      return;
    }

    sendAnalyticsEvent('teladoc_link_click');
  };

  return (
    <SidebarWrapper>
      <Title>{header_mtm}</Title>
      <Subheader>{sub_header}</Subheader>

      {button_label && (
        <CTAButton
          href={button_link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={sendInsightsOnCTAClick}
        >
          {button_label} <ArrowRight size={16} style={{ marginLeft: 4 }} />
        </CTAButton>
      )}

      {signup_code && (
        <CodeContainer>
          <p>{button_header || 'Your sign-up code'}</p>
          <CodeBox onClick={handleCopy}>
            <CopyIconWrapper role="button" aria-label="Copy signup code">
              <Copy size={20} />
              <span>{signup_code}</span>
            </CopyIconWrapper>
          </CodeBox>
          <CopiedWrapper>
            {copied && (
              <CopiedComponent>
                <CopiedIcon />
                Copied!
              </CopiedComponent>
            )}
          </CopiedWrapper>
        </CodeContainer>
      )}
    </SidebarWrapper>
  );
};
